import React from 'react'
import { AlertTriangleIcon } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import {
	Empty,
	EmptyDescription,
	EmptyHeader,
	EmptyMedia,
} from '@/shared/components/ui/empty'
import { cn } from '@/shared/lib/utils'

export function WidgetErrorFallback({
	size = 'medium',
	className,
}: {
	size?: 'small' | 'medium'
	className?: string
}) {
	const { t } = useTranslation()

	return (
		<Empty className={cn('md:px-4', className)}>
			<EmptyHeader>
				<EmptyMedia
					variant='icon'
					className='bg-destructive/20 text-destructive'
				>
					<AlertTriangleIcon />
				</EmptyMedia>
				<EmptyDescription
					className={cn('text-destructive', {
						'text-xs': size === 'small',
					})}
				>
					{t('error.unrecoverable.title')}
				</EmptyDescription>
			</EmptyHeader>
		</Empty>
	)
}
